import { render, staticRenderFns } from "./DishValued.vue?vue&type=template&id=49cd1daa&"
import script from "./DishValued.vue?vue&type=script&lang=js&"
export * from "./DishValued.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports